module.exports = __webpack_public_path__ + "img/c0aab0e.jpg";